import { FileRecord, MerchantUserPortfolioImageDto } from "@/models/club";
import clubRequest from "../axios";

export interface PortfolioImage {
  id: number;
  image: FileRecord;
  description?: string | null;
  order: number;
}

export interface StaffPortfolio {
  merchantUserId: number;
  description: string | null;
  images: PortfolioImage[];
}

function portfolioImage(image: MerchantUserPortfolioImageDto): PortfolioImage {
  if (!image.id || !image.image)
    throw new Error("پاسخ تصویر نمونه‌کار نامعتبر است");
  return {
    id: image.id,
    image: image.image,
    description: image.description ?? "",
    order: image.order ?? 0,
  };
}

export const getPortfolio = async (id: number): Promise<StaffPortfolio> => {
  const { data } = await clubRequest.merchantUserPortfolioList({ id });
  return {
    merchantUserId: id,
    description: data.description ?? "",
    images: (data.images ?? []).map(portfolioImage),
  };
};

export const uploadPortfolioImage = async (
  merchantUserId: number,
  file: File,
): Promise<PortfolioImage> => {
  const { data } = await clubRequest.merchantUserPortfolioImageCreate({
    MerchantUserId: merchantUserId,
    File: file,
  });
  return portfolioImage(data);
};

export const savePortfolio = async (portfolio: StaffPortfolio) =>
  clubRequest.merchantUserPortfolioUpdate({
    merchantUserId: portfolio.merchantUserId,
    description: portfolio.description,
    images: portfolio.images.map(({ id, description }) => ({
      id,
      description: description ?? "",
    })),
  });

export const saveStaffOrder = async (ids: number[]) =>
  clubRequest.merchantUserOrderUpdate({ ids });

export function moveItem<T>(items: T[], from: number, to: number): T[] {
  if (from < 0 || to < 0 || from >= items.length || to >= items.length)
    return items;
  const next = [...items];
  next.splice(to, 0, next.splice(from, 1)[0]);
  return next;
}

export function validatePortfolioFiles(
  files: File[],
  existingCount: number,
): string | null {
  if (existingCount + files.length > 30)
    return "حداکثر ۳۰ تصویر مجاز است. برای افزودن تصویر جدید، ابتدا حذف تصاویر قبلی را ذخیره کنید.";
  if (files.some((file) => !/\.(jpe?g|png|gif)$/i.test(file.name)))
    return "فقط تصاویر jpg، jpeg، png و gif مجاز هستند.";
  if (files.some((file) => file.size > 10 * 1024 * 1024))
    return "حجم هر تصویر باید حداکثر ۱۰ مگابایت باشد.";
  return null;
}
